// ...
import 'bulma/css/bulma.css';
// ...

import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

Vue.prototype.$eventData = [
  {
    id: 1,
    name: 'Developer',
    description: 'I have been an Independent Developer for many years.  Mostly doing applications for live sporting events.',
    short: 'Developed the first mobile app for the Tour of France',
    long: 'I have been developing mobile applications for 10+ years.  I am available to help you with your development needs.  If you have an idea that you want to pass by me I am more then happy to consult with you.  I have been responsible for some of the most used sporting applications in the world.',
    featuredImage: 'https://farm4.staticflickr.com/3244/2738488282_4b1bf04220_z.jpg'
  },
  {
    id: 2,
    name: 'Photography',
    description: 'You Can find many of my photos available via the creative commons license.',
    short: 'Statues and more Statues....',
    long: 'As part of my world travels I have picked up photography as a hobby.  However I do have some photos available for sale as part of Getty Images.  For the rest of my work, I post it to Flickr under the creative commons license.  I do ask that when you use one of my photos that you let me know how it was used as I like to at least try and support those that have used my work.',
    featuredImage: 'https://farm4.staticflickr.com/3384/3424579427_f6d36ec59b_z.jpg'
  },
  {
     id: 3,
     name: 'World Traveler',
     description: 'My Goal is to travel to every country at least once.  Where else are you going to see a donkey eating cigarettes?',
     short: 'Counting down the list of countries',
     long: "I love to go an explore the world and see all of the sites and culture.  My goal is to try and visit each and every country at least once.  Some of the great experiances have always been unplanned, like being in Rome the day after the pope was announced, or turning that corner only to see some interesting building or statue, and what is better then just by happen stance being in the country that wins the World Cup.  Just remember with traveling as long as you have a working credit card.. it doesn't matter what you forget at home.",
     featuredImage: 'https://farm3.staticflickr.com/2187/2223361756_eedd1f7328_z.jpg'
  },
]

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
